import React from 'react'

function Contact() {
  return (
    <div name="contact" className='w-full h-screen bg-gradient-to-b from-black to-gray-800 p-4 text-white' >
      <div className='flex flex-col p-4 justify-center max-w-screen-lg mx-auto h-full'>
        <div className='pb-8'>
            <p className='text-4xl font-bold inline border-b-4 border-gray-500 p-2'>
                Contact
            </p>
            <p className='py-6'>
                Submit the form to get in touch with me
            </p>
        </div>
        <div className='flex justify-center items-center'>
            <form action="https://getform.io/f/3f7dc3b1-6d33-43a0-a86b-d9262c8d8693" method='POST' className='flex flex-col w-full md:w-1/2'>
                <input type="text" name="name" placeholder="Enter your name" className='  p-2 bg-transparent border-2 rounded-md text-white focus:outline-none'/>
                <input type="email" name='name'  placeholder=' Enter your Email' className='my-4 p-2 bg-transparent border-2 rounded-md text-white focus:outline-none'/>
                <textarea name="meessage" placeholder='Enter your message...' id="" cols="30" rows="10" className='p-2 bg-transparent border-2 rounded-md text-white focus:outline-none'></textarea>
                <button className='text-white  bg-gradient-to-b from-cyan-500 to-blue-700 px-6 py-3 my-3 mx-auto flex items-center rounded-md hover:scale-110 duration-300 '>Let's talk</button>
                
            </form>
            
        </div>
      </div>
    </div>
  )
}

export default Contact
